import { render, staticRenderFns } from "./GoogleBusinessUpdateReviewStatus.vue?vue&type=template&id=991c853a&scoped=true"
import script from "./GoogleBusinessUpdateReviewStatus.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessUpdateReviewStatus.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessUpdateReviewStatus.vue?vue&type=style&index=0&id=991c853a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c853a",
  null
  
)

export default component.exports